import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Modal from "../components/elements/Modal";
import Button from "../components/form/Button";

const CheckProfile = ({ children }) => {
  const profile = useSelector((state) => state?.profileSlice?.data);
  const check = profile?.completeProfile;
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [pending, setPending] = useState(null);

  useEffect(() => {
    if (
      user &&
      check &&
      user?.roleCode === "user" &&
      (!check?.isPersonalComplete ||
        !check?.isBillingComplete ||
        !check?.isLanguageComplete ||
        (user?.cardsDetails &&
          Array.isArray(user?.cardsDetails) &&
          user?.cardsDetails.length === 0))
    ) {
      setIsOpen(true);
      if (!check?.isPersonalComplete) {
        setPending("Personal Info");
        return;
      }
      if (!check?.isBillingComplete) {
        setPending("Billing Info");
        return;
      }
      if (user?.cardsDetails.length === 0) {
        setPending("Payment Information");
        return;
      }
      if (!check?.isLanguageComplete) {
        setPending("Language Info");
        return;
      }
    } else if (
      user &&
      check &&
      user?.roleCode === "consultant" &&
      (!check?.isMemberComplete ||
        !check?.isPersonalComplete ||
        !check?.isBillingComplete ||
        // !check?.isInsuranceComplete ||
        !check?.isStripeCompleted ||
        !check?.isServiceComplete ||
        !check?.isDailyScheduleComplete ||
        !check?.isSpecializationComplete ||
        !check?.isLanguageComplete)
    ) {
      setIsOpen(true);
      if (!check?.isPersonalComplete) {
        setPending("Personal Info");
        return;
      }
      if (!check?.isBillingComplete) {
        setPending("Billing Info");
        return;
      }
      if (!check?.isStripeCompleted) {
        setPending("Payment Info");
        return;
      }
      if (!check?.isMemberComplete) {
        setPending("Member Info");
        return;
      }
      if (!check?.isSpecializationComplete) {
        setPending("Fields of Intervention Info");
        return;
      }
      if (!check?.isLanguageComplete) {
        setPending("Language Info");
        return;
      }
      if (!check?.isServiceComplete) {
        setPending("Service Info");
        return;
      }
      if (!check?.isDailyScheduleComplete) {
        setPending("Daily Schedule Info");
        return;
      }
    }
  }, [user, check]);

  const handleOkClick = () => {
    setIsOpen(false);
    navigate("/profile", { replace: true });
  };

  if (isOpen) {
    return (
      <Modal
        isOpen={isOpen}
        titleShow={false}
        bodyClass="2xl:!w-3/12 lg:w-4/12 md:w-7/12 w-full"
      >
        <div className="relative flex flex-col items-center py-5">
          <div className="text-5xl mb-3 text-prontopsy-pink">
            <i className="fa-sharp fa-regular fa-circle-exclamation"></i>
          </div>
          <h2 className="text-2xl text-center font-bold text-prontopsy-blue mb-1">
            Confirmation Alert
          </h2>
          <p className="text-sm text-center mb-4">Complete Your {pending}</p>
          <Button
            buttonLabel={"Ok"}
            buttonClasses={"mt-4 !px-12"}
            buttonFunction={handleOkClick}
          />
          <Button
            buttonIcon={"fa-solid fa-xmark"}
            buttonIconPosition={"left"}
            buttonClasses={
              "!absolute !bg-transparent -top-3 -right-2 !text-black !rounded-full !bg-white !shadow-md !px-2 !text-xl"
            }
            buttonHasLink={false}
            buttonFunction={handleOkClick}
          />
        </div>
      </Modal>
    );
  }

  return children;
};

export default CheckProfile;
